<template>
    <div class="flex h-auto bg-gray-900 text-white">
      <!-- Sidebar -->
      <aside class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-lg">
        <div class="flex items-center justify-center space-x-3">
       <img src="@/assets/logo.svg" alt="Syniac Logo" class="h-20">
        </div>
        <Navbar></Navbar>
      </aside>
      
      <!-- Main Content -->
      <div class="flex-1 flex flex-col">
        <!-- Top Navbar -->
        <header class="h-16 bg-gray-800 flex items-center justify-between px-6 shadow-md">
          <h2 class="text-xl font-semibold">Affiliates</h2>
        </header>
        
        <!-- Dashboard Overview -->
        <main class="p-6 flex-1">
          <div class="grid grid-cols-3 gap-6">
            <div class="bg-gray-800 p-6 rounded-xl shadow-md">
              <h3 class="text-lg font-semibold">Total Users</h3>
              <p class="text-3xl font-bold">{{ totalUsers }}</p>
            </div>
            <div class="bg-gray-800 p-6 rounded-xl shadow-md">
              <h3 class="text-lg font-semibold">Total Referrals</h3>
              <p class="text-3xl font-bold">{{ totalReferrals }}</p>
            </div>
            <div class="bg-gray-800 p-6 rounded-xl shadow-md">
              <h3 class="text-lg font-semibold">Total Earnings</h3>
              <p class="text-3xl font-bold">${{ totalEarnings }}</p>
            </div>
          </div>
          
          <!-- User List -->
          <div class="mt-6 bg-gray-800 p-6 rounded-xl shadow-md">
            <h3 class="text-lg font-semibold mb-4">Affiliate Users</h3>
            <table class="w-full text-left">
              <thead>
                <tr class="border-b border-gray-700">
                  <th class="p-2">User ID</th>
                  <th class="p-2">Referral Code</th>
                  <th class="p-2">Total Referrals</th>
                  <th class="p-2">Total Earnings</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="user in users" :key="user.id" class="border-b border-gray-700">
                  <td class="p-2">{{ user.id }}</td>
                  <td class="p-2">{{ user.affid }}</td>
                  <td class="p-2">{{ user.affreferrals }}</td>
                  <td class="p-2">${{ user.affearnings }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </main>
      </div>
    </div>
  </template>
  
  <script>
  import Navbar from '@/components/adminnav.vue';
  import axios from 'axios';
  
  export default {
    name: "AdminDashboard",
    data() {
      return {
        totalUsers: 0,
        totalReferrals: 0,
        totalEarnings: 0,
        users: []
      };
    },
    methods: {
      async fetchAffiliateData() {
        try {
          const response = await axios.get("https://api.syniac.com:3000/api/admin/affiliate/affiliates", { withCredentials: true });
          this.totalUsers = response.data.totalUsers;
          this.totalReferrals = response.data.totalReferrals;
          this.totalEarnings = response.data.totalEarnings;
          this.users = response.data.users;
        } catch (error) {
          console.error("Error fetching admin data:", error);
        }
      }
    },
    created() {
      this.fetchAffiliateData();
    },
    components: {
      Navbar
    }
  };
  </script>
  
